function countdown() {

    _.each($('.countdown'),function(e){
      var $countdown = $(e),
      eventTime = moment($countdown.data('time'), 'HH:mm:ss').unix(),
      currentTime = moment().unix(),
      diffTime = eventTime - currentTime,
      duration = moment.duration(diffTime * 1000, 'milliseconds'),
      interval = 1000,
      isWeekend = moment().format('e') == 0 || moment().format('e') == 6

      // if time to countdown
      if(diffTime > 0 && !isWeekend) {

        // Show countdown
        $countdown.fadeIn();
        $countdown.next('.countdown--text').fadeIn();

        var $d = $('.countdown-days'),
        $h = $('.countdown-hours'),
        $m = $('.countdown-minutes'),
        $s = $('.countdown-seconds');

        function updateClock() {

          duration = moment.duration(duration.asMilliseconds() - interval, 'milliseconds');

          if (duration._milliseconds < 0) {
            $countdown.hide();
            return;
          }

          var d = moment.duration(duration).days(),
          h = moment.duration(duration).hours(),
          m = moment.duration(duration).minutes(),
          s = moment.duration(duration).seconds();

          d = $.trim(d).length === 1 ? '0' + d : d;
          h = $.trim(h).length === 1 ? '0' + h : h;
          m = $.trim(m).length === 1 ? '0' + m : m;
          s = $.trim(s).length === 1 ? '0' + s : s;

          // show how many hours, minutes and seconds are left
          $d.text(d);
          $h.text(h);
          $m.text(m);
          $s.text(s);

        };

        updateClock();

        setInterval(function () {
          updateClock();
        }, 1000);
      } else {
        $countdown.hide();
      }
    });

  }

  countdown();
